/* GEHNA FOR YOU — Nav hover + Sticky ATC cart-aware fix */
(function(){
  'use strict';

  /* ── 1. Hover dropdowns on desktop nav ── */
  function enableHoverDropdowns() {
    if(window.innerWidth < 990) return;
    document.querySelectorAll('.header__inline-menu details').forEach(function(details) {
      var timer;
      details.addEventListener('mouseenter', function() {
        clearTimeout(timer);
        details.setAttribute('open', '');
      });
      details.addEventListener('mouseleave', function() {
        timer = setTimeout(function() { details.removeAttribute('open'); }, 120);
      });
      var caret = details.querySelector('.icon-caret');
      if(caret) {
        new MutationObserver(function() {
          caret.style.transform = details.hasAttribute('open') ? 'rotate(180deg)' : 'none';
          caret.style.opacity   = details.hasAttribute('open') ? '1' : '0.65';
        }).observe(details, { attributes: true, attributeFilter: ['open'] });
      }
    });
  }

  /* ── 2. Hide sticky ATC bar when cart drawer is open ──
     Dawn adds 'overflow-hidden' to body when ANY drawer is open.
     Also watch cart-drawer for 'open' attribute and 'active' class. */
  function initStickyATCCartAware() {
    function getATC() { return document.querySelector('.gehna-sticky-atc'); }

    function isCartOpen() {
      /* Dawn sets overflow-hidden on body when cart drawer slides open */
      if(document.body.classList.contains('overflow-hidden')) return true;
      var cd = document.querySelector('cart-drawer, #CartDrawer');
      if(!cd) return false;
      return cd.classList.contains('active') ||
             cd.hasAttribute('open') ||
             cd.getAttribute('aria-hidden') === 'false';
    }

    function update() {
      var atc = getATC();
      if(!atc) return;
      if(isCartOpen()) {
        atc.classList.remove('visible');
        atc.style.display = 'none';
      } else {
        atc.style.display = '';
        /* Re-check intersection to decide if it should be visible */
        var origBtn = document.querySelector('.product-form__submit');
        if(origBtn) {
          var rect = origBtn.getBoundingClientRect();
          var inView = rect.top >= 0 && rect.bottom <= window.innerHeight;
          atc.classList.toggle('visible', !inView);
        }
      }
    }

    /* Watch body class for overflow-hidden */
    new MutationObserver(update).observe(document.body, {
      attributes: true, attributeFilter: ['class']
    });

    /* Also watch cart-drawer element */
    var cd = document.querySelector('cart-drawer, #CartDrawer');
    if(cd) {
      new MutationObserver(update).observe(cd, {
        attributes: true, attributeFilter: ['class', 'open', 'aria-hidden']
      });
    }

    /* Listen to Shopify cart events */
    document.addEventListener('cart:open',  function(){ var a=getATC(); if(a){a.style.display='none';a.classList.remove('visible');} });
    document.addEventListener('cart:close', function(){ var a=getATC(); if(a){a.style.display='';} });
    /* Dawn dispatches these custom events */
    document.addEventListener('CartDrawer:open',  function(){ var a=getATC(); if(a){a.style.display='none';a.classList.remove('visible');} });
    document.addEventListener('CartDrawer:close', function(){ var a=getATC(); if(a){a.style.display='';} });
  }

  function init() {
    enableHoverDropdowns();
    initStickyATCCartAware();
  }

  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', enableHoverDropdowns);

})();
